import type { HTMLAttributes } from "react";

/**
 * Small uppercase label used above section headings.
 */
export function Eyebrow({ className = "", children, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={`text-eyebrow text-[var(--color-accent-base)] ${className}`.trim()}
      {...rest}
    >
      {children}
    </span>
  );
}
